import React, { useState, useEffect, useCallback } from 'react'
import { useSelector } from 'react-redux'
import { selectSkillName } from '../../../../redux/skillSlice'
import constants, { capitalise } from '../../../../utilities/constants'
import ExpandedSyllabus from './ExpandedSyllabus'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faArrowRight, faCheck } from '@fortawesome/free-solid-svg-icons'
import useWindowSize from '../../../../hooks/useWindowSize'
import Lottie from 'lottie-react'
import EvenMainPricingCard from './EvenMainPricingCard'
import { selectIsEvenUser } from '../../../../redux/onboardingUserDetails'
import { Mixpanel } from '../../../../config/Mixpanel'
import OneTimePricingCard from './OneTimePricingCard'
import OddMainPricingCardV2 from './OddMainPricingCardV2'




const MainPricingCard = ({ onUnlockAccess, onViewSyllabus, notSubscribedUser, razorpayHandler, mainCTAref, isPlacementAddonSelected, discountedPrice, originalPrice, setisPlacementAddonSelected, setShowPlacementModal, showPlacementModal, isCouponApplied, setIsCouponApplied, couponSectionRef, discountedPriceWithoutAddon, originalPriceWithoutAddon, isOneTime, setIsOneTime ,originalPriceEvenUser, discountedPriceEvenUser, razorpayHandlerEvenUser, originalPriceOneRupee, discountedPriceOneRupee, razorpayHandlerOddUser ,timeLeft, discountedPriceOneTime, originalPriceOneTime, discountedPriceOddUser, originalPriceOddUser, isProAddonSelected, setisProAddonSelected}) => {
  const skillName = useSelector(selectSkillName) || 'Product Management'

  // Timer state - 15 minutes in seconds


  // Confetti state
  const [showConfetti, setShowConfetti] = useState(false)
  const [confettiData, setConfettiData] = useState(null)

  // Highlight state for coupon section
  const [isHighlighted, setIsHighlighted] = useState(false)

  const { width } = useWindowSize()
  const evenUser = useSelector(selectIsEvenUser);


  // Timer effect
 

  // Load confetti animation
  useEffect(() => {
    const loadConfetti = async () => {
      try {
        const response = await fetch('/confetti.json')
        const data = await response.json()
        setConfettiData(data)
      } catch (error) {
        console.error('Failed to load confetti animation:', error)
      }
    }
    loadConfetti()
  }, [])

  // Handle coupon apply with confetti
  const handleApplyCoupon = () => {
    Mixpanel.track(constants.Mixpanel.ONBOARDING_V2_PRICING_PAGE_COUPON_APPLIED)
    setShowConfetti(true)
    setIsCouponApplied(true)

    // Hide confetti after animation completes (typically 3-4 seconds)
    setTimeout(() => {
      setShowConfetti(false)
    }, 4000)
  }

  // Function to scroll to coupon section and highlight it
  const scrollToCoupon = useCallback(() => {
    if (couponSectionRef?.current) {
      couponSectionRef.current.scrollIntoView({
        behavior: 'smooth',
        block: 'center'
      })

      // Add highlight effect
      setIsHighlighted(true)

      // Remove highlight after animation
      setTimeout(() => {
        setIsHighlighted(false)
      }, 2000)
    }
  }, [couponSectionRef])

  // Pass scroll function to parent via useEffect
  React.useEffect(() => {
    if (window.scrollToCouponSection) {
      window.scrollToCouponSection = scrollToCoupon
    }
  }, [scrollToCoupon])

  // Set the global function on mount
  React.useEffect(() => {
    window.scrollToCouponSection = scrollToCoupon
    return () => {
      delete window.scrollToCouponSection
    }
  }, [scrollToCoupon])

  // Format time as MM:SS
  const formatTime = (seconds) => {
    const minutes = Math.floor(seconds / 60)
    const remainingSeconds = seconds % 60
    return `${minutes}M : ${remainingSeconds.toString().padStart(2, '0')}s`
  }

  return (
    <div className="w-full flex flex-col items-start relative shrink-0 w-full mx-auto" data-node-id="1641:10979">

      <ExpandedSyllabus onViewSyllabus={onViewSyllabus} />
      {notSubscribedUser && <div className='font-bold text-[24px] mt-8 leading-[130%] capitalize'>{evenUser ? 'Choose How you want to start learning' : ''}</div>}
      {/* Main Card Container */}
      <div className="mt-4 bg-gradient-to-b content-stretch flex flex-col from-[rgba(64,106,255,0.1)] items-center justify-center pt-[2px] px-[2px] relative rounded-[24px] shrink-0 to-[rgba(38,64,153,0.1)] w-full" data-node-id="1641:10981">
        <div className="content-stretch flex flex-col items-start relative shrink-0 w-full" data-node-id="1641:10982">
          <div className="content-stretch flex flex-col items-center p-[16px] relative shrink-0 w-full" data-node-id="1641:10983">
           {evenUser ? 

     
            <EvenMainPricingCard
            skillName={skillName}
            notSubscribedUser={notSubscribedUser}
            isPlacementAddonSelected={isPlacementAddonSelected}
            discountedPriceWithoutAddon={discountedPriceWithoutAddon}
            originalPrice={originalPrice}
            discountedPrice={discountedPrice}
            handleApplyCoupon={handleApplyCoupon}
            couponSectionRef={couponSectionRef}
            isHighlighted={isHighlighted}
            isCouponApplied={isCouponApplied}
            setisPlacementAddonSelected={setisPlacementAddonSelected}
            mainCTAref={mainCTAref}
            razorpayHandler={razorpayHandler}
            isOneTime={isOneTime}
            setIsOneTime={setIsOneTime}
            setShowPlacementModal={setShowPlacementModal}
            originalPriceEvenUser={originalPriceEvenUser}
            discountedPriceEvenUser={discountedPriceEvenUser}
            razorpayHandlerEvenUser={razorpayHandlerEvenUser}
            discountedPriceOneTime={discountedPriceOneTime}
            originalPriceOneTime={originalPriceOneTime}
            isProAddonSelected={isProAddonSelected}
            setisProAddonSelected={setisProAddonSelected}
            />
            : <OddMainPricingCardV2 
            skillName={skillName}
            notSubscribedUser={notSubscribedUser}
            isPlacementAddonSelected={isPlacementAddonSelected}
            discountedPriceOddUser={discountedPriceOddUser}
            originalPriceOddUser={originalPriceOddUser}
            mainCTAref={mainCTAref}
            razorpayHandler={razorpayHandler}
            setisPlacementAddonSelected={setisPlacementAddonSelected}
            setShowPlacementModal={setShowPlacementModal}
            isProAddonSelected={isProAddonSelected}
            setisProAddonSelected={setisProAddonSelected}
            width={width}
            />}
            
            
          </div>
        </div>
      </div>

      {/* Timer Section */}
      {notSubscribedUser && <div className="w-full p-[1px] rounded-[12px] mt-6" style={{
        backgroundImage: `linear-gradient(
  to right,
  #E45B4F 0%,
  #84261E 100%
)`}}>
        <div className="w-full flex flex-col justify-center items-center rounded-[12px] text-[12px] font-semibold p-3" data-node-id="1641:11034" style={{
          background: "linear-gradient(to right, #01101C 0%, #02243F 50%, #01101C 100%)"
        }}>
          <p className=" font-normal leading-none not-italic text-white text-center uppercase" data-node-id="1641:11035">
            Price reserved for you for <span className='text-[#EA4335]'>{formatTime(timeLeft)}</span>
          </p>
          <p className="font-normal leading-none not-italic text-[10px] text-white/30 font-normal text-center mt-2" data-node-id="1641:11036">
            Based on your analysis • expires soon
          </p>
        </div>
      </div>}

      {/* Confetti Animation Overlay */}
      {showConfetti && confettiData && (
        <div className="fixed inset-0 pointer-events-none z-50 flex items-center justify-center">
          <Lottie
            animationData={confettiData}
            loop={false}
            autoplay={true}
            style={{
              width: '100vw',
              height: '100vh',
              position: 'absolute',
              top: 0,
              left: 0,
            }}
          />
        </div>
      )}
    </div>
  )
}

export default MainPricingCard